export const errorStatesConfig = ({msg, user})=>{
    
 return{  
    401:{
        layout: "center",
        img: "image401",
        imgSize: 200,
        title: !user
            ? "You don’t have permission to view this. Check if you’re logged in, then try again."
            : 'You don’t have permission to view this. This content isn’t available to your role. Contact your administrator if you need access.',
        subTitle:   msg.msg
    }, 
    400:{
        layout: "center",
        img: "image400",
        imgSize: 200,
        title: "Your client requested a malformed or illegal request",
        subTitle:   msg.msg
    },
    403: {
        layout: "center",
        img: "image403",
        imgSize: 200,
        title: "Error 403",
        subTitle:  msg.msg
    },
    404: {
        layout: "center",
        img: "image404",
        imgSize: 200,
        title: "We cannot find the page you are looking for",
        subTitle: msg.msg
    },
    500: {
        layout: "center",
        img: "image500",
        imgSize: 200,
        opacity:0.8,  
        title: "The server encountered an error",
        subTitle:  msg.msg
    },
    503: {
        layout: "center",
        img: "image500",
        imgSize: 200,
        opacity:0.8,  
        title: "Device is offline. Unable to fetch this page :(",
        subTitle:  msg.msg
    }}
}

export const statusInclude=(status)=>{
    return Object.keys(errorStatesConfig()).includes(status)
}